import {
  Box,
  Text,
  Flex,
  Divider,
  Heading,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";
import { CountdownTimer } from "../CountdownTimer/CountdownTimer";
import { pulse } from "../../constants";
import { css } from "@emotion/react";
import logo from "../../assets/image/logo-light.png";

function GiveawayBanner() {
  const contestEndDate = new Date("2025-09-01T00:00:00-06:00");

  const pulseAnimation = css`
    animation: ${pulse} 2s infinite;
  `;

  const gridItemInfo = [
    {
      title: "Rounds of Ammo",
      value: "80,000",
    },
    {
      title: "Winner",
      value: "1",
    },
    {
      title: "To Enter",
      value: "Free",
    },
    {
      title: "Brass Case",
      value: "9mm",
    },
  ];

  return (
    <Box
      maxW={"7xl"}
      mx={"auto"}
      mt={"80px"}
      className="relative w-full max-w-5xl mx-auto"
    >
      <Box
        py={{ base: 6, md: 12 }}
        px={{ base: 3, md: 6 }}
        bgGradient="linear(to-r, #0a0f2a, #1a2563, #0a0f2a)"
        rounded="xl"
        shadow="2xl"
        overflow="hidden"
      >
        <Box
          className="relative z-10"
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Flex
            direction={{ base: "column", md: "row" }}
            align="center"
            justify="center"
            mb={6}
            pt={4}
            gap={4}
            w={"100%"}
            maxW={"1055px"}
          >
            <Box
              w={{ base: 40, md: 56 }}
              h={{ base: 40, md: 56 }}
              display="flex"
              justifyContent="center"
              flexShrink={1}
            >
              <Image
                // src="https://cdn.bulletscout.com/image/logo-light.png"
                src={logo}
                alt="Scout Logo"
                width={224}
                height={224}
                style={{ objectFit: "contain" }}
              />
            </Box>

            <Divider
              display={{ base: "none", md: "block" }}
              orientation="vertical"
              borderColor="blue.300"
              height="6rem"
              mx={4}
            />

            <Flex
              flexShrink={2}
              flexDirection={"column"}
              flex="1"
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Heading
                as="h2"
                size={{ base: "xl", lg: "3xl", xl: "4xl" }}
                fontWeight="extrabold"
                color="white"
                mb={4}
                display={"flex"}
                gap={"8px"}
                w={"100%"}
                justifyContent={"center"}
                lineHeight={1}
                fontFamily={'"Geist", sans-serif'}
              >
                FREE AMMO{" "}
                <Text
                  as="span"
                  color="blue.400"
                  textShadow="0px 0px 12px rgba(59,130,246,0.9)"
                  css={pulseAnimation}
                >
                  FOR LIFE
                </Text>
              </Heading>

              <Box mt={3}>
                <Heading
                  as={"h2"}
                  size={{ base: "xl", lg: "3xl", xl: "4xl" }}
                  fontWeight="extrabold"
                  textTransform="uppercase"
                  color="white"
                  letterSpacing="tight"
                  fontFamily={'"Geist", sans-serif'}
                >
                  Giveaway
                </Heading>
              </Box>
            </Flex>
          </Flex>

          <Box textAlign="center">
            <Text
              fontSize={{ base: "xl", sm: "2xl", md: "3xl", lg: "4xl" }}
              color="blue.100"
              mb={8}
              fontFamily={'"Geist", sans-serif'}
            >
              One Free Case Per Year For 80 Years
            </Text>
            <Grid
              templateColumns={{
                base: "1fr",
                sm: "1fr 1fr",
                lg: "repeat(4, 1fr)",
              }}
              gap={{ base: 4, md: 2 }}
              mb={6}
            >
              {gridItemInfo.map((item, index) => {
                return (
                  <GridItem
                    bg="whiteAlpha.100"
                    backdropBlur="sm"
                    backdropFilter="blur(4px)"
                    borderRadius="lg"
                    p={4}
                    textAlign="center"
                    w={{ base: "100%", md: "240px" }}
                    justifySelf={"center"}
                    key={index}
                  >
                    <Text
                      fontSize={{ base: "3xl", sm: "4xl" }}
                      fontWeight="bold"
                      color="white"
                      fontFamily={'"Geist", sans-serif'}
                    >
                      {item.value}
                    </Text>
                    <Text
                      fontFamily={'"Geist", sans-serif'}
                      color="blue.200"
                      fontSize="sm"
                    >
                      {item.title}
                    </Text>
                  </GridItem>
                );
              })}
            </Grid>

            <CountdownTimer endDate={contestEndDate} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default GiveawayBanner;
